import { AuthenticationModel, SwitchProjectModel } from './dto/authenticationModel'
import { AuthenticationResultModel } from './dto/authenticationResultModel'
import http, { ApiRequestConfig } from '../httpService'

class TokenAuthService {
  public async authenticate(authenticationInput: AuthenticationModel, config?: ApiRequestConfig): Promise<AuthenticationResultModel> {
    const result = await http.post('api/TokenAuth/Authenticate', authenticationInput, config)
    return result.data.result
  }

  public async switchProject(targetProjectId): Promise<AuthenticationResultModel> {
    const result = await http.post('api/TokenAuth/SwitchProjectAuthenticate', null,{params: {targetProjectId}})
    return SwitchProjectModel.assign(result.data.result)
  }

  public async getLoginMethod(): Promise<any> {
    const result = await http.get('api/TokenAuth/GetAuthenticationProviders')
    return result.data.result
  }

  public async socialAuth(body: any, config?: ApiRequestConfig): Promise<any> {
    const result = await http.post('api/TokenAuth/ExternalAuthenticateV1', body, config)
    return result.data.result
  }

  public async checkPhoneNumber(phoneNumber) {
    const result = await http.post('api/services/app/Account/IsPhoneNumberAvailable', {phoneNumber})
    return result.data.result
  }
  // checkSocial (IsSocialLoginAvailable) removed together with the
  // self-registration flows — it only pre-checked first-time social sign-ups.



  public async SMSAuth(body: any): Promise<any> {
    const result = await http.post('api/TokenAuth/PhoneLoginAuthenticate', body)
    return result.data.result
  }

  // Self-registration service calls removed together with the
  // /account/register flows (internal CRM, admin-provisioned accounts).


}

export default new TokenAuthService()
